/**
* Sketch Intro JS
* -----------------------------------------------------------------------------
*
* All the JS for the Sketch Intro component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'sketch-intro',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mm = gsap.matchMedia();

      mm.add( '(min-width: 1024px)', () => {
        const xPx = $( '.sketch-intro__inner' )[0].scrollWidth;

        $( '.sketch-intro__desktop .sketch-intro__inner' ).each( function( key, val ) {
          const tableBox = $( '.sketch-intro__room-table' )[0].getBBox();
          const table = {
            originX: tableBox.x + tableBox.width * 0.19,
            originY: tableBox.y + tableBox.height * 0.27,
            startX: 0,
            startY: tableBox.height * 1,
          };

          const sittingAreaBox = $( '.sketch-intro__room-sitting-area' )[0].getBBox();
          const sittingArea = {
            originX: sittingAreaBox.x + sittingAreaBox.width * 0.86,
            originY: sittingAreaBox.y + sittingAreaBox.height * 0.61,
            startX: -50,
            startY: sittingAreaBox.height * -2,
          };

          const benchBox = $( '.sketch-intro__room-bench' )[0].getBBox();
          const bench = {
            originX: benchBox.x + benchBox.width * 0.20,
            originY: benchBox.y + benchBox.height * 0.71,
            startX: 0,
            startY: benchBox.height * 2,
          };

          const doorBox = $( '.sketch-intro__door' )[0].getBBox();
          const door = {
            originX: doorBox.x - 2,
            originY: doorBox.y + 3,
            startX: 0,
            startY: 0,
          };

          const pinner = gsap.timeline( {
            scrollTrigger: {
              trigger: '.sketch-intro__desktop',
              pin: true,
              pinSpacing: true,
              end: '+=3000',
              scrub: 1,
            },
          } );

          const scroller = gsap.timeline( {
            scrollTrigger: {
              trigger: '.sketch-intro__desktop',
              start: 'top top',
              end: '+=3000',
              scrub: 1,
            },
          } );

          // Draw the walls
          scroller.fromTo( '.sketch-intro__draw-in', {
            strokeDasharray: 1400,
            strokeDashoffset: 1400,
          }, {
            strokeDashoffset: 0,
            ease: 'none',
            duration: 0.5,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-wall--top', {
            clipPath: 'inset(0% 100% 0% 0%)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 0.5,
            duration: 0.2,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-wall--right', {
            clipPath: 'inset(0% 0% 100% 0%)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 0.7,
            duration: 0.2,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-wall--bottom', {
            clipPath: 'inset(0% 0% 0% 100%)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 0.9,
            duration: 0.2,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-wall--left', {
            clipPath: 'inset(100% 0% 0% 0%)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 1.1,
            duration: 0.2,
          }, 0 );

          // Display the furniture
          scroller.fromTo( '.sketch-intro__room-table', {
            opacity: 0,
          }, {
            opacity: 1,
            ease: 'none',
            delay: 1.2,
            duration: 0.2,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-sitting-area', {
            opacity: 0,
          }, {
            opacity: 1,
            ease: 'none',
            delay: 1.2,
            duration: 0.2,
          }, 0 );

          // Display content 1
          scroller.fromTo( '.sketch-intro__panel-text--1', {
            opacity: 0,
            y: '5%',
          }, {
            opacity: 1,
            y: 0,
            ease: 'none',
            delay: 1.2,
            duration: 0.2,
          }, 0 );

          // Hide content 1
          scroller.to( '.sketch-intro__panel-text--1', {
            opacity: 0,
            y: '-5%',
            ease: 'none',
            delay: 1.5,
            duration: 0.2,
          }, 0 );

          // Move the table
          scroller.fromTo( '.sketch-intro__room-table', {
            x: table.startX,
            y: table.startY,
            svgOrigin: `${table.originX} ${table.originY}`,
          }, {
            x: 0,
            y: 0,
            svgOrigin: `${table.originX} ${table.originY}`,
            ease: 'none',
            delay: 1.5,
            duration: 0.3,
          }, 0 );

          // Rotate the sitting area
          scroller.fromTo( '.sketch-intro__room-sitting-area', {
            rotate: -90,
            svgOrigin: `${sittingArea.originX} ${sittingArea.originY}`,
          }, {
            rotate: 0,
            svgOrigin: `${sittingArea.originX} ${sittingArea.originY}`,
            ease: 'none',
            delay: 1.5,
            duration: 0.3,
          }, 0 );

          // Move the sitting area
          scroller.fromTo( '.sketch-intro__room-sitting-area__wrapper', {
            x: sittingArea.startX,
            y: sittingArea.startY,
            svgOrigin: `${sittingArea.originX} ${sittingArea.originY}`,
          }, {
            x: 0,
            y: 0,
            svgOrigin: `${sittingArea.originX} ${sittingArea.originY}`,
            ease: 'none',
            delay: 1.5,
            duration: 0.3,
          }, 0 );

          // Display bench
          scroller.fromTo( '.sketch-intro__room-bench', {
            opacity: 0,
          }, {
            opacity: 1,
            ease: 'none',
            delay: 1.7,
            duration: 0.1,
          }, 0 );

          // Move the bench
          scroller.fromTo( '.sketch-intro__room-bench', {
            x: bench.startX,
            y: bench.startY,
            svgOrigin: `${bench.originX} ${bench.originY}`,
          }, {
            x: 0,
            y: 0,
            svgOrigin: `${bench.originX} ${bench.originY}`,
            ease: 'none',
            delay: 1.6,
            duration: 0.3,
          }, 0 );

          // Display content 2
          scroller.fromTo( '.sketch-intro__panel-text--2', {
            opacity: 0,
            y: '5%',
          }, {
            opacity: 1,
            y: 0,
            ease: 'none',
            delay: 1.7,
            duration: 0.2,
          }, 0 );

          scroller.to( '.sketch-intro__room-wall--bottom', {
            opacity: 0,
            ease: 'none',
            delay: 1.9,
            duration: 0.1,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room-wall--bottom-partial', {
            opacity: 0,
          }, {
            opacity: 1,
            ease: 'none',
            delay: 1.9,
            duration: 0.1,
          }, 0 );

          scroller.fromTo( '.sketch-intro__room', {
            clipPath: 'inset(0% 0% 19.1% -1000vw)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 1.9,
            duration: 0.1,
          }, 0 );

          // Open the door
          scroller.fromTo( '.sketch-intro__door', {
            rotate: -90,
            svgOrigin: `${door.originX} ${door.originY}`,
          }, {
            rotate: 0,
            svgOrigin: `${door.originX} ${door.originY}`,
            ease: 'none',
            delay: 2.1,
            duration: 0.3,
          }, 0 );

          // Display content 3
          scroller.fromTo( '.sketch-intro__door-path', {
            clipPath: 'inset(0% 0% 100% 0%)',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
            delay: 2.1,
            duration: 0.3,
          }, 0 );

          // Display content 3
          scroller.fromTo( '.sketch-intro__panel-text--3', {
            opacity: 0,
            y: '5%',
          }, {
            opacity: 1,
            y: 0,
            ease: 'none',
            delay: 2.2,
            duration: 0.2,
          }, 0 );

          // Horizontally scroll the component
          scroller.to( '.sketch-intro__inner', {
            x: ( ( xPx - window.innerWidth ) * -1 ),
            ease: 'none',
          }, 0 );
        } );
      } );

      mm.add( '(max-width: 1023px)', () => {
        $( '.sketch-intro__mobile' ).each( function() {
          const mobileDrawIn = gsap.timeline( {
            scrollTrigger: {
              trigger: '.sketch-intro__mobile-inner',
              start: 'top 50%',
              end: 'bottom 50%',
              scrub: 1,
            },
          } );

          mobileDrawIn.fromTo( '.sketch-intro__mobile-draw-in path', {
            strokeDashoffset: 1400,
            strokeDasharray: 1400,
          }, {
            strokeDashoffset: 0,
            ease: 'none',
          }, 0 );

          const mobileDoorSwing = gsap.timeline( {
            scrollTrigger: {
              trigger: '.sketch-intro__mobile-door__wrapper',
              start: 'top 75%',
              end: '+=172px',
              scrub: 1,
            },
          } );

          // Display content 3
          mobileDoorSwing.fromTo( '.sketch-intro__mobile-door-path', {
            clipPath: 'inset(0% 0% 100% 0%)',
            ease: 'none',
          }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none',
          }, 0 );

          mobileDoorSwing.to( '.sketch-intro__mobile-door', {
            rotate: '90deg',
            ease: 'none',
          }, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'sketch-intro', COMPONENT );
} )( app );
